import { Link } from "react-router-dom";
import Hero from "../components/home/Hero";
import Features from "../components/home/Features";
import AssociationStory from "../components/home/AssociationStory";
import CookieConsent from "../components/CookieConsent";
import Stats from "../components/home/Stats";
import "./../styles/HomePage.css";

export default function HomePage() {
  return (
    <div className="homepage">
      <CookieConsent />

      <section className="homepage__hero">
        <Hero />
      </section>

      <section className="homepage__stats">
        <Stats />
      </section>

      <section className="homepage__features">
        <Features />
      </section>

      <section className="homepage__story">
        <AssociationStory />
      </section>

      <section className="homepage__final-cta">
        <div className="homepage__final-cta-inner">
          <p className="homepage__kicker">Besoin d'une première orientation ?</p>
          <h2>Expliquez votre situation, NMS06 vous aide à la rendre claire.</h2>
          <p>
            Ce texte peut être adapté selon le parcours exact choisi par
            l'équipe : contact direct, inscription, rendez-vous ou première
            analyse.
          </p>
          <div className="homepage__final-actions">
            <Link to="/contact" className="homepage__cta-primary">
              Obtenir de l'aide
            </Link>
            <a href="#outils-nms" className="homepage__cta-secondary">
              Découvrir les outils
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
